import { AsciiText } from '../framework/AsciiText';
const debug = true;
export class AshlyNeDsp {
    constructor(socket, log) {
        // Create channels for a 12x12 system.
        this.socket = socket;
        this.log = log;
        this.inChans = [];
        this.outChans = [];
        this.presets = [];
        // Bit definitions for 2 more input cards and 2 output cards
        //
        //byte 0:      5              4                3           2                1           0
        //             Exp1           Exp1             Exp2        Exp2             Exp3        Exp3
        //             present: 1     type: 1 (input)  present: 1  type: 1 (input)  present: 1  type: 0 (output)
        //
        //
        //byte 1:      5              4                x           x                 1             0
        //             Exp4           Exp4             0           0                 front switch  switch type
        //             present: 1     type: 0 (output)                               enabled: 0    device id: 0
        //
        // [0x3e, 0x20]  for 3 input cards and 3 output cards
        //
        // [0x20, 0x00] for 0 input cards and 1 output expansion card
        // [0x00, 0x00] for 0 input and 0 output cads
        this.expansionCards = [0x3e, 0x20]; // assume 2 input card and 2 output cards for 12x12 system
        this.currentPreset = 0;
        this.asyncHandlers = [
            {
                name: 'configurationGet',
                regExp: /^\xf0\x00\x01\x2a\x06\x00\x00\x00\x00/,
                callback: (match) => {
                    this.socket.send(this.makeConfigResponse());
                },
            },
            {
                name: 'muteVolumeGetInputOutput',
                regExp: /^\xf0\x00\x01\x2a\x06\x00\x00(\x01|\x02)([\s\S])/,
                callback: (match) => {
                    const isInput = match[1].charCodeAt(0) === 0x01;
                    const num = match[2].charCodeAt(0);
                    if (isInput) {
                        const channel = this.inChans[num];
                        if (debug) {
                            this.log.debug(`emulator: get input status channel = ${JSON.stringify(channel)}`);
                        }
                        this.socket.send(this.makeInputResponse(channel));
                    }
                    else {
                        const channel = this.outChans[num];
                        if (debug) {
                            this.log.debug(`emulator: get output status channel = ${JSON.stringify(channel)}`);
                        }
                        this.socket.send(this.makeOutputResponse(channel));
                    }
                },
            },
            {
                name: 'muteCrossPointSet',
                regExp: /^\xf0\x00\x01\x2a\x06\x00\x19([\s\S])([\s\S])([\s\S])/,
                callback: (match) => {
                    const outChanNum = match[1].charCodeAt(0) - 0x40;
                    const inChanNum = match[2].charCodeAt(0);
                    const muteValue = match[3].charCodeAt(0) === 0x01;
                    const channel = this.outChans[outChanNum];
                    channel.crossPoints[inChanNum].mute = muteValue;
                    if (debug) {
                        this.log.debug(`emulator: get output status channel = ${JSON.stringify(channel)}`);
                    }
                    this.socket.send(this.makeOutputResponse(channel));
                },
            },
            {
                name: 'presetNameGet',
                regExp: /^\xf0\x00\x01\x2a\x06\x00\x04$/,
                callback: (match) => {
                    this.socket.send(this.makePresetNameResponse());
                },
            },
            {
                name: 'presetRecall',
                regExp: /^\xf0\x00\x01\x2a\x06\x00\x07([\s\S])[\s\S]$/,
                callback: (match) => {
                    this.currentPreset = match[1].charCodeAt(0);
                    // no response to a preset recall as far as I can tell
                    // for testing presets 1 (index 0) and 2 (index 1) use input 1 to output 1
                    // crosspoint mute
                    if (this.currentPreset === 0) {
                        this.outChans[0].crossPoints[0].mute = true;
                        this.outChans[0].crossPoints[1].mute = true;
                    }
                    else if (this.currentPreset === 1) {
                        this.outChans[0].crossPoints[0].mute = false;
                        this.outChans[0].crossPoints[1].mute = true;
                    }
                    // for testing presets 3 (index 2) and 3 (index 2) use input 2 to output 1
                    // crosspoint mute
                    if (this.currentPreset === 2) {
                        this.outChans[0].crossPoints[0].mute = true;
                        this.outChans[0].crossPoints[1].mute = true;
                    }
                    else if (this.currentPreset === 3) {
                        this.outChans[0].crossPoints[0].mute = true;
                        this.outChans[0].crossPoints[1].mute = false;
                    }
                },
            },
            {
                name: 'volumeCrossPointSet',
                regExp: /^\xf0\x00\x01\x2a\x06\x00\x12([\s\S])([\s\S])([\s\S])/,
                callback: (match) => {
                    const outChanNum = match[1].charCodeAt(0) - 0x40;
                    const inChanNum = match[2].charCodeAt(0);
                    const gain = match[3].charCodeAt(0);
                    const channel = this.outChans[outChanNum];
                    channel.crossPoints[inChanNum].gain = gain;
                    if (debug) {
                        this.log.debug(`emulator: set crosspoint status channel = ${JSON.stringify(channel)}`);
                    }
                    this.socket.send(this.makeOutputResponse(channel));
                },
            },
            {
                name: 'volumeSet',
                regExp: /^\xf0\x00\x01\x2a\x06\x00\x0c([\s\S])([\s\S]{2})/,
                callback: (match) => {
                    const gain = (match[2].charCodeAt(0) << 7) + match[2].charCodeAt(1);
                    let channelNumber = match[1].charCodeAt(0);
                    if (channelNumber >= 0x40) {
                        // output channel
                        channelNumber -= 0x40;
                        const channel = this.outChans[channelNumber];
                        channel.volume = gain;
                        if (debug) {
                            this.log.debug(`emulator: set volume channel = ${JSON.stringify(channel)}`);
                        }
                        this.socket.send(this.makeOutputResponse(channel));
                    }
                    else {
                        const channel = this.inChans[channelNumber];
                        channel.volume = gain;
                        if (debug) {
                            this.log.debug(`emulator: set volume channel = ${JSON.stringify(channel)}`);
                        }
                        this.socket.send(this.makeInputResponse(channel));
                    }
                },
            },
            {
                name: 'muteSet',
                regExp: /^\xf0\x00\x01\x2a\x06\x00\x15([\s\S])([\s\S])/,
                callback: (match) => {
                    const muteValue = match[2].charCodeAt(0) === 0x01;
                    let channelNumber = match[1].charCodeAt(0);
                    if (channelNumber >= 0x40) {
                        // output channel
                        channelNumber -= 0x40;
                        const channel = this.outChans[channelNumber];
                        channel.mute = muteValue;
                        if (debug) {
                            this.log.debug(`emulator: set mute channel = ${JSON.stringify(channel)}`);
                        }
                        this.socket.send(this.makeOutputResponse(channel));
                    }
                    else {
                        const channel = this.inChans[channelNumber];
                        channel.mute = muteValue;
                        if (debug) {
                            this.log.debug(`emulator: set mute channel = ${JSON.stringify(channel)}`);
                        }
                        this.socket.send(this.makeInputResponse(channel));
                    }
                },
            },
        ];
        const numInputs = 12;
        const numOutputs = 12;
        // The API output response always uses 20 crosspoints per output regardless of the number
        // of inputs defined.
        const numCrossPointsPerOutput = 20;
        for (let inp = 0; inp < numInputs; inp++) {
            this.inChans[inp] = {
                name: `Input ${inp + 1}`,
                chanNum: inp,
                mute: false,
                volume: 8192, // 0 dB
            };
        }
        for (let outp = 0; outp < numOutputs; outp++) {
            // Add 20 crosspoints to each output.
            const xpArray = [];
            for (let j = 0; j < numCrossPointsPerOutput; j++) {
                xpArray.push({ mute: false, gain: 0x33 }); // 0 dB
            }
            this.outChans[outp] = {
                name: `Output ${outp + 1}`,
                chanNum: outp,
                mute: false,
                volume: 8192,
                crossPoints: xpArray,
            };
        }
        // While the manual indicates 32 presets are supported, the API returns names for 35 presets
        // x 20 characters = 700 characters.
        for (let i = 0; i < 35; i++) {
            this.presets.push(`Preset ${i + 1}`);
        }
    }
    makeConfigResponse() {
        const result = [];
        result.push(0xf0, 0x00, 0x01, 0x2a, 0x06, 0x00); // header
        result.push(0x01); // response header
        result.push(0x00); // configuration response
        result.push(...AsciiText.encode('Ashly DSP'.padEnd(20, ' ')));
        result.push(...this.expansionCards);
        result.push(this.currentPreset); // current loaded preset
        result.push(0x3f); //dsp status: all installed
        return AsciiText.decode(result);
    }
    makePresetNameResponse() {
        const result = [];
        result.push(0xf0, 0x00, 0x01, 0x2a, 0x06, 0x00); // header
        result.push(0x05); // preset name response
        for (let i = 0; i < 35; i++) {
            result.push(...AsciiText.encode(this.presets[i].padEnd(20, ' ')));
        }
        return AsciiText.decode(result);
    }
    makeInputResponse(chan) {
        const result = [];
        result.push(0xf0, 0x00, 0x01, 0x2a, 0x06, 0x00); // header
        result.push(0x01); // response header
        result.push(0x01); // input channel
        result.push(chan.chanNum); // zero based
        result.push(...AsciiText.encode(chan.name.padEnd(20, ' ')));
        result.push(chan.mute ? 0x01 : 0x00);
        result.push(0x00); // eq bypassed
        result.push(0x00, 0x00); // preamp gain, phantom power status
        result.push((chan.volume >> 7) & 0x7f); // gain bits 13 - 7
        result.push(chan.volume & 0x7f); // gain bits 6 - 0
        result.push(0x00); // normal polarity
        result.push(0x00, 0x00, 0x00); // delay bytes
        result.push(0x00, 0x00, 0x00, 0x00, 0x00); // gate info
        result.push(0x00, 0x00, 0x00, 0x00, 0x00, 0x00); // auto leveler
        for (let numFilters = 1; numFilters <= 15; numFilters++) {
            result.push(0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00); // eq filters
        }
        result.push(0x00, 0x00, 0x00, 0x00);
        // position 159 bytes
        return AsciiText.decode(result);
    }
    makeOutputResponse(chan) {
        const result = [];
        result.push(0xf0, 0x00, 0x01, 0x2a, 0x06, 0x00); // header
        result.push(0x01); // response header
        result.push(0x02); // output channel
        result.push(chan.chanNum); // output channel number
        result.push(...AsciiText.encode(chan.name.padEnd(20, ' ')));
        result.push(chan.mute ? 0x01 : 0x00); // mute status
        result.push(0x00); // eq bypassed
        result.push(0x7f, 0x7f, 0x3f); // mix status routing enabled
        // submix of inputs to this output
        for (let inNum = 0; inNum < 20; inNum++) {
            // set bit 6 as mute, gain uses bits 5 to 0
            const xp = (chan.crossPoints[inNum].gain & 0x3f) + (chan.crossPoints[inNum].mute ? 1 << 6 : 0);
            result.push(xp);
        }
        result.push(0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00); // hp/lp filters
        result.push(0x00, 0x00, 0x00); // delay bytes
        for (let numFilters = 1; numFilters <= 15; numFilters++) {
            result.push(0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00); // eq filters
        }
        result.push((chan.volume >> 7) & 0x7f); // gain bits 13-7
        result.push(chan.volume & 0x7f); // gain bits 6-0
        result.push(0x00); // normal polarity
        result.push(0x00, 0x00, 0x00, 0x00, 0x00, 0x00); // limiter info
        // position 179 bytes
        return AsciiText.decode(result);
    }
}
AshlyNeDsp.emulatorType = 'socketEmulator';
AshlyNeDsp.key = '-Ne3aaBFpBJLbhJKTuJy';
